import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../api";
import { UpdateType } from "../../domains/Schedule";
import { createError, HTTPErrors } from "../../errors";
import SectionInterface from "../../interfaces/SectionInterface";

type Props = {
  section: SectionInterface;
  onSuccess: () => void;
  onError: () => void;
};

type MutationParams = {
  scheduleId: string;
  updateType: UpdateType;
};

export const useDeleteSectionSchedule = ({
  section,
  onSuccess,
  onError,
}: Props) => {
  const client = useQueryClient();

  return useMutation<unknown, HTTPErrors, MutationParams>({
    mutationFn: async ({ scheduleId, updateType }: MutationParams) => {
      const res = await api.delete(urlOf(section, scheduleId), {
        update_type: updateType,
      });
      if (res.ok) {
        return;
      }
      throw await createError(res);
    },
    onSuccess() {
      client.invalidateQueries({ queryKey: ["section/schedules"] });
      onSuccess();
    },
    onError,
  });
};

const urlOf = (section: SectionInterface, scheduleId: string) =>
  `/api/v1/sections/${section.id}/schedules/${scheduleId}`;
